import { scrollToActiveItem } from './components/active-item';
import { horizontalScroll } from './components/horizontal-scroll';
import { addPaddingToMenuItem } from './components/total-width';
import { arrowNavigation } from './components/arrow-navigation';

( function () {
	const mediaQuery = window.matchMedia( '(max-width: 440px)' );
	if ( ! mediaQuery.matches ) {
		return;
	}

	const navContainer = document.querySelector( '.masthead-lower__article ul' );
	const navItems = document.querySelectorAll( '.masthead-lower__article-item' );
	const entryContent = document.querySelector( '.entry-content' );
	const allFirstElements = Array.from( entryContent.children );
	let observer = null;
	let viewportHeight = window.innerHeight;

	// Observe area just below the in-page navigation with only 5px area of observation.
	let rootMargin = `-160px 0% -${ viewportHeight - 165 }px 0%`;
	let sections = null;
	let previousSection = null;
	let link = null;

	// User interaction flags.
	let hasUserClicked = false;

	// Cache the intersecting entry
	let currentEntry = null;

	/**
	 * Intersection Observer Options.
	 */
	const intersectionOptions = {
		// The rootMargin may need to be different for Recipe and Comment sections.
		rootMargin: rootMargin,
		// threshold will probably need to be adjust depending on comments, recipe card, etc.
		threshold: 0, //[ 0.25, 0.5, 0.75, 1 ],
		// trackVisibility: true,
		// delay: 100
	};

	if ( ! navItems || navItems.length < 1 ) {
		return;
	}

	// Enable the horizontal scroll.
	horizontalScroll( navContainer );

	// Add padding to the menu items.
	window.addEventListener( 'load', () => {
		addPaddingToMenuItem( navItems );
		// Initiate Arrow Navigation.
		arrowNavigation();
	} );

	/**
	 * Reset the user interacted flag.
	 */
	function resetUserInteractedFlag() {
		setTimeout( () => {
			hasUserClicked = false;
		}, 1000 ); // This is dependent on the page length as well as the page scroll speed.
	}

	/**
	 * Handle Link Click.
	 *
	 * @param {object} event
	 */
	function handleLinkClick( event ) {
		event.preventDefault();

		hasUserClicked = true;

		// Reset flag after click.
		resetUserInteractedFlag();

		let link = event.currentTarget?.firstChild;
		const section = document.getElementById( link.dataset.src );

		// Set the offset for the scroll.
		let offset = section?.offsetTop != null ? section.offsetTop - 65 : 0;
		if ( section?.id?.includes( 'wprm-recipe-container-' ) || section?.id === 'recipe' ) {
			// Needs to match the jump button for recipe card.
			offset = section.offsetTop + 37; // 190
		} else if ( section?.id?.includes( 'comments' ) || section?.id === 'respond' ) {
			offset = section.offsetTop - 45; // 110
		}

		currentEntry = section;

		// Need to add support for FAQ, also note there can be more than one FAQ block on a page.
		// This looks like faq-block-1, faq-block-2, etc.
		if ( section?.id?.includes( 'faq-block-' ) ) {
			offset = section.offsetTop - 60;
		}

		const onScroll = () => {
			if ( window.scrollY.toFixed() === offset.toFixed() ) {
				window.removeEventListener( 'scroll', onScroll );
				hasUserClicked = false;
			}
		};

		window.addEventListener( 'scroll', onScroll );
		onScroll();

		window.scroll( {
			behavior: 'smooth',
			top: offset,
		} );

		navItems.forEach( ( item ) => {
			item.classList.remove( 'is-visible' );
		} );

		// Make sure clicked item is set to visible.
		link.parentElement.classList.add( 'is-visible' );

		highlightActiveItem();

		previousSection = section?.dataset?.target;

		scrollToActiveItem( '.masthead-lower__article-item.active', navContainer );

		// replaceState doesn't replace the browser
		if ( link === 'top' ) {
			history.replaceState( null, null, window.location.href.split( '#' )[ 0 ] );
		} else {
			history.replaceState( null, null, `#${ link.dataset.src }` );
		}

		// Send data to GTM.
		window.dataLayer = window.dataLayer || [];
		dataLayer.push( {
			event: 'gtm.linkClick',
			gtm: {
				elementUrl: '#' + link.dataset.src,
				elementText: link.innerText,
				elementTarget: '_self',
				willOpenInNewWindow: false,
			},
		} );
	}

	const handleObserver = ( entries ) => {
		if ( hasUserClicked ) {
			return;
		}

		entries.forEach( ( entry ) => {
			if ( entry.isIntersecting ) {
				if (
					currentEntry &&
					currentEntry.isEqualNode( entry.target ) &&
					entry.target.dataset.target === 'jump-dozer'
				) {
					return;
				}

				currentEntry = entry.target;

				let sectionId = `${ entry.target.dataset.target }`,
					link = navContainer.querySelector( `button[data-src="${ sectionId }"]` );

				const activeLink = link;
				const currentSectionId = activeLink?.parentElement;

				// Don't run if the current section is already visible.
				if ( previousSection && previousSection === sectionId ) {
					return;
				}

				navItems.forEach( ( navItem ) => {
					navItem.classList.remove( 'is-visible' );
				} );

				currentSectionId.classList.add( 'is-visible' );

				highlightActiveItem();

				const previousLink = currentSectionId.querySelector( 'button' )?.dataset?.src;
				if ( previousLink ) {
					previousSection = previousLink;
				}

				scrollToActiveItem( '.masthead-lower__article-item.active', navContainer );

				if ( sectionId === 'top' ) {
					// RTES-636 - Special handling for Slickstream, so that the panel can be closed.
					if ( document.querySelector( 'html' ).classList.contains( 'slick-search-panel-showing' ) ) {
						history.replaceState( null, null, '#search' );
					} else {
						// Remove fragment from URL once scroll to top.
						history.replaceState( null, null, window.location.href.split( '#' )[ 0 ] );
						navContainer.scrollTo( 0, 0 );
					}
				} else {
					// replaceState doesn't replace the browser
					history.replaceState( null, null, `#${ sectionId }` );
				}

				return;
			}
		} );
	};

	/**
	 * Highlight the first active link.
	 */
	const highlightActiveItem = () => {
		let firstVisibleLink = document.querySelector( '.is-visible' );

		// Remove all active classes.
		navItems.forEach( ( navItem ) => {
			navItem.classList.remove( 'active' );
		} );

		if ( firstVisibleLink ) {
			firstVisibleLink.classList.add( 'active' );
		}

		if ( ! firstVisibleLink && previousSection ) {
			link = document.querySelector( `button[data-src="${ previousSection }"]` );
			link.parentElement?.classList.add( 'active' );
		}
	};

	const getPreviousSiblingForComments = ( el ) => {
		const prevSibling = el.previousElementSibling;

		if ( prevSibling.classList.contains( 'comment-respond' ) ) {
			return getPreviousSiblingForComments( prevSibling );
		}

		if ( prevSibling.classList.contains( 'screen-reader-text' ) ) {
			return getPreviousSiblingForComments( prevSibling );
		}

		return prevSibling;
	};

	/**
	 * Set up the observer.
	 */
	const setUpObserver = () => {
		observer = new IntersectionObserver( handleObserver, intersectionOptions );
	};

	/**
	 * Observe the sections.
	 */
	const observeSections = () => {
		sections = Array.from( navItems )
			.map( ( navItem ) => {
				const srcID = navItem.firstChild?.dataset?.src;

				return document.getElementById( srcID );
			} )
			.filter( ( section ) => section !== null );

		// Add the first section, it's should be paragraph or image.
		let firstElement = entryContent.querySelector( 'p, img, figure, div' );
		firstElement.setAttribute( 'data-target', 'top' );
		sections.unshift( firstElement );

		// Also need to add entry-header to the sections.
		const entryHeader = document.querySelector( '.entry-header' );
		entryHeader.setAttribute( 'data-target', 'top' );
		sections.unshift( entryHeader );

		sections.forEach( ( section ) => {
			// Add data-target to the section if it's not already set.
			if ( ! section.dataset.target ) {
				section.setAttribute( 'data-target', section.id );
			}

			observer.observe( section );
		} );

		// Loop through the sections and get the previous sibling of each sections.
		let prevSectionID = 'top';
		sections.forEach( ( section ) => {
			let previousSibling = section.previousElementSibling;

			// If section is not the first level element child, get the first level element child.
			if ( ! allFirstElements.includes( section ) ) {
				previousSibling = section.parentElement.previousElementSibling;
			}

			// If previousSibling is adThrive, get the previous sibling of the adThrive.
			if ( previousSibling?.classList.contains( 'adthrive-ad' ) ) {
				previousSibling = previousSibling.previousElementSibling;
			}

			// Edge case where the previous sibling is a <hr>
			if ( previousSibling?.offsetHeight <= 50 ) {
				previousSibling = previousSibling?.previousElementSibling;
			}

			// Edge case to make sure the menu item above comments is correctly highlighted.
			if ( section.id === 'comments' ) {
				previousSibling = getPreviousSiblingForComments( section );
			}

			if ( ! previousSibling ) {
				// Skip this section.
				return;
			}

			// Requires the previous sibling to have a height at least 50px.
			// This is to preventing jumping to the previous section too early.
			if ( previousSibling.offsetHeight > 50 ) {
				// Add attribute data-target to the previous sibling.
				previousSibling.setAttribute( 'data-target', prevSectionID );
				observer.observe( previousSibling );
			}

			// Store the previous section ID.
			prevSectionID = section.dataset.target;
		} );
	};

	// Initialize the navigation.
	function initNavigation() {
		setUpObserver();
		observeSections();

		navItems.forEach( ( item ) => {
			item.addEventListener( 'click', handleLinkClick );
		} );
	}

	window.addEventListener( 'load', () => {
		initNavigation();
	} );
} )();
